import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Monogram } from "@/components/Navbar";

const KEY = "sls_disclaimer_acknowledged";

export default function EntryDisclaimer() {
  const [visible, setVisible] = useState(() => {
    try {
      return !localStorage.getItem(KEY);
    } catch {
      return true;
    }
  });
  const [exited, setExited] = useState(false);

  const accept = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <AnimatePresence>
      <motion.div
        data-testid="entry-disclaimer-modal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="grain fixed inset-0 z-[100] flex items-center justify-center bg-ink px-5"
        role="dialog"
        aria-modal="true"
        aria-labelledby="entry-disclaimer-heading"
      >
        {!exited ? (
          <div className="w-full max-w-2xl border border-gold/25 bg-navy p-8 sm:p-14">
            <div className="flex justify-center"><Monogram size="h-14 w-14" textSize="text-sm" /></div>
            <p className="mono-label mt-8 text-center">Smart Legal Solutions</p>
            <h2 id="entry-disclaimer-heading" className="mt-4 text-center font-serif text-3xl font-medium text-ivory sm:text-4xl">
              Professional Website Disclaimer
            </h2>
            <div className="mx-auto mt-6 h-px w-24 bg-gold/60" />
            <p className="mt-8 text-center text-sm leading-relaxed text-ivory/70 sm:text-base">
              The information available on this website is provided solely for general informational purposes. It is not
              intended to solicit legal work or advertise professional services. Access to this website is voluntary. The
              material does not constitute legal advice and should not be relied upon as a substitute for advice based on
              the facts and documents of a particular matter. Viewing the website or sending an enquiry does not create an
              advocate-client relationship.
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <button data-testid="entry-disclaimer-agree-button" onClick={accept} className="btn-outline-gold w-full justify-center sm:w-auto">
                I Understand and Continue
              </button>
              <button data-testid="entry-disclaimer-exit-button" onClick={() => setExited(true)} className="btn-ghost-ivory w-full justify-center sm:w-auto">
                Exit Website
              </button>
            </div>
          </div>
        ) : (
          <div className="w-full max-w-lg border border-gold/25 bg-navy p-10 text-center sm:p-14">
            <div className="flex justify-center"><Monogram size="h-14 w-14" textSize="text-sm" /></div>
            <h2 className="mt-8 font-serif text-3xl font-medium text-ivory">You May Close This Tab</h2>
            <p className="mt-5 text-sm leading-relaxed text-ivory/60">
              You have chosen not to proceed. Please close this browser tab or window. If you arrived here by mistake, you
              may reconsider below.
            </p>
            <button data-testid="entry-disclaimer-reconsider-button" onClick={() => setExited(false)} className="btn-outline-gold mt-10 justify-center">
              Return to Disclaimer
            </button>
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
